import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

const banners = [
  { url: '/images/banner1.jpg', info: 'Know more about Banner 1', onClick: () => alert('Clicked Know More for Banner 1') },
  { url: '/images/banner2.jpg', info: 'Know more about Banner 2', onClick: () => alert('Clicked Know More for Banner 2') },
  { url: '/images/banner3.jpg', info: 'Know more about Banner 3', onClick: () => alert('Clicked Know More for Banner 3') },
  { url: '/images/banner4.jpg', info: 'Know more about Banner 4', onClick: () => alert('Clicked Know More for Banner 4') },
];

export default function BannerSlider() {
  return (
    <div style={{ background: '#eff5f7ff', color: 'white', textAlign: 'center', padding: '20px 0 20px 0' }}>
      <Slide arrows duration={3000} transitionDuration={500} infinite>
        {banners.map(({ url, info, onClick }, index) => (
          <div key={index}>
            <img src={url} alt={`banner${index + 1}`} style={{ width: '100%', height: '380px', objectFit: 'cover', margin: '0 auto' }} />
            <button
              onClick={onClick}
              style={{
                marginTop: '20px',
                padding: '10px 24px',
                fontSize: '18px',
                cursor: 'pointer',
                backgroundColor: 'rgba(13, 97, 7, 1)',
                color: '#f5efefff',
                border: 'none',
                borderRadius: '4px',
              }}
            >
              Know More
            </button>
          </div>
        ))}
      </Slide>
    </div>
  );
}
